import { PermissionCheck } from "../Access/helper/permission/PermissionCheck";

export const getTransactionInitStatus = () => {
    const draftOnly = PermissionCheck.withCurrentRoute().hasSomeModifier(['M3']);
    const requireApproval = PermissionCheck.withCurrentRoute().hasSomeModifier(['M4']);

    if (requireApproval)
        return 'pending_approval';
    if (draftOnly)
        return 'draft';
    return 'ready';
};
